import React, { useLayoutEffect, useRef } from 'react';
import { landingMarqueeDurationFromTrackWidth } from '../utils/landingPageAnalytics';

/**
 * Horizontally scrolling keyword pills. Duration scales with track width so
 * visual speed stays constant regardless of how many keywords are shown.
 */
export default function LandingKeywordMarquee({ keywords }) {
  const trackRef = useRef(null);
  const appliedDurationRef = useRef(null);
  const keywordsKey = keywords.join('\0');

  useLayoutEffect(() => {
    const el = trackRef.current;
    if (!el || keywords.length === 0) return;

    const applyDuration = () => {
      const width = el.scrollWidth;
      if (width <= 0) return;
      const nextSec = landingMarqueeDurationFromTrackWidth(width);
      const prevSec = appliedDurationRef.current;
      if (prevSec != null && Math.abs(prevSec - nextSec) < 0.5) return;
      appliedDurationRef.current = nextSec;
      el.style.animationDuration = `${nextSec}s`;
    };

    applyDuration();
    const observer = new ResizeObserver(applyDuration);
    observer.observe(el);
    return () => {
      observer.disconnect();
      appliedDurationRef.current = null;
    };
  }, [keywords.length, keywordsKey]);

  return (
    <div className="overview-live-themes__marquee" role="presentation">
      <div ref={trackRef} className="overview-live-themes__marquee-track">
        {keywords.map((keyword, index) => (
          <span className="overview-theme-pill" key={`m-a-${keyword}-${index}`}>
            <span className="overview-theme-pill__dot" aria-hidden />
            {keyword}
          </span>
        ))}
        {keywords.map((keyword, index) => (
          <span className="overview-theme-pill" aria-hidden="true" key={`m-b-${keyword}-${index}`}>
            <span className="overview-theme-pill__dot" aria-hidden />
            {keyword}
          </span>
        ))}
      </div>
    </div>
  );
}
